import { gql } from "@apollo/client";

export const BANK_NAME_LOOKUP = gql`
  mutation AccountNameLookup($payload: AccountNameLookupDto!) {
    accountNameLookup(payload: $payload)
  }
`;
